import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import ProjPicMaryamCourt from "../Components/ProjPicMaryamCourt";

const ProjectPageMaryamCourt = () => {
    return (
        <>
            <Navbar />
            <ProjPicMaryamCourt />
            <Footer />
        </>
    );
};

export default ProjectPageMaryamCourt;
